<template>
    <section
        id="form"
        class="header-iframe-container"
    >
        <div class="header-iframe">
            <!-- eslint-disable vue/no-v-html -->
            <div
                class="header-iframe__title"
                :class="[pageHeader.subtitle ? 'header-iframe__title--active-sub' : '']"
                v-html="pageHeader.title"
            ></div>
            <div
                v-if="pageHeader.subtitle"
                class="header-iframe__subtitle"
                v-html="pageHeader.subtitle"
            ></div>
            <div class="header-iframe__inner">
                <div class="header-iframe__details">
                    <div
                        class="header-iframe__sellingpoints"
                    >
                        <div
                            v-for="(sellingPoint, index) in pageHeader.selling_points"
                            :key="index"
                            class="header-iframe__sellingpoints-inner"
                        >
                            <div class="header-iframe__image">
                                <img
                                    :src="sellingPoint.icon.url"
                                    :alt="sellingPoint.headline"
                                    loading="lazy"
                                    :width="sellingPoint.image?.width > 1 ? sellingPoint.image.width : null"
                                    :height="sellingPoint.image?.height > 1 ? sellingPoint.image.height : null"
                                >
                            </div>
                            <div class="header-iframe__text">
                                <span class="header-iframe__popper-container">
                                    <Popper
                                        placement="top"
                                        arrow
                                    >
                                        <button class="header-iframe__popper-button">{{ sellingPoint.headline }}</button>
                                        <template #content>
                                            <div class="header-iframe__popper-description">{{ sellingPoint.description }}</div>
                                        </template>
                                    </Popper>
                                </span>
                                <span class="header-iframe__headline">
                                    {{ sellingPoint.headline }}
                                </span>

                                <p class="header-iframe__description">
                                    {{ sellingPoint.description }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <Media
                        :type="pageHeader.media_type"
                        :inline="true"
                    />
                </div>

                <div class="header-iframe__iframe">
                    <iframe
                        width="100%"
                        height="350"
                        :src="pageHeader.iframe"
                        allowtransparency="true"
                    ></iframe>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import Popper from 'vue3-popper';
import Media from '../../header-components/media/watson-theme-header-media.vue';

defineProps({
    pageHeader: {
        type: Object,
        required: false,
        default: null,
    },
});
</script>

<style lang="scss" scoped>
@use "watson-theme-header-iframe";
</style>
